import { IconBullet16, IconMilitaryMortgage16 } from '@cian/ui-kit';
import * as React from 'react';

import { EPromoType } from 'shared/types/newbuildingPromos';

export const QUANTITY_PROMOS_IN_ROW = 2;

export const BANK_ICON_MAP: { [key: string]: React.ReactNode } = {
  [EPromoType.MaternalCapital]: <IconBullet16 color="gray_icons_100" />,
  [EPromoType.MilitaryMortgage]: <IconMilitaryMortgage16 color="success_100" />,
};
